module.exports = __webpack_public_path__ + "img/Fire.1ad6721.svg";